import type { ReactNode } from "react";

interface BulletListProps {
  /** The `<li>` items. */
  children: ReactNode;
}

/**
 * A bulleted list of short points — the notes inside a Banner, the caveats
 * under a form. Indents from the bullet so the markers stay inside the
 * surrounding box rather than hanging into its padding.
 */
export function BulletList({ children }: BulletListProps) {
  return (
    <ul className="mt-2 mb-1 list-disc ps-4 marker:text-content-muted">
      {children}
    </ul>
  );
}
